import { css } from 'styled-components';

//styleName: typography/ParagraphSmall/Primary/Regular;
const typographyParagraphSmallPrimaryRegular = css`
  font-family: Heebo, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`;

const typographyPTSansNarrow10 = css`
  font-family: PT Sans Narrow;
  font-size: 10px;
  font-weight: 400;
  line-height: 12px;
  letter-spacing: 0px;
`;

//styleName: typography/BadgeSmall/Condensed/Bold;
const typographyBadgeSmallCondensedBold = css`
  font-family: PT Sans Narrow;
  font-size: 14px;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: 0px;
`;

//styleName: typography/Body/Primary/Medium;
const typographyBodyPrimaryMedium = css`
  font-family: Heebo, sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0px;
`;

//styleName: typography/LabelSmall/Primary/Regular;
const typographyLabelSmallPrimaryRegular = css`
  font-family: Heebo, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0px;
`;

//styleName: typography/LabelXSmall/Primary/Medium;
const typographyLabelXSmallPrimaryMedium = css`
  font-family: Heebo, sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0px;
`;

// No stylename indicated in Figma
const typographyHeebo12 = css`
  font-family: Heebo, sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
`;

// No stylename indicated in Figma
const typographyHeebo14Bold = css`
  font-family: Heebo, sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
`;

// No stylename indicated in Figma
const typographyHeebo24 = css`
  font-family: Heebo, sans-serif;
  font-size: 24px;
  font-weight: 500;
  line-height: 36px;
`;

export {
  typographyParagraphSmallPrimaryRegular,
  typographyHeebo12,
  typographyHeebo14Bold,
  typographyHeebo24,
  typographyBodyPrimaryMedium,
  typographyLabelSmallPrimaryRegular,
  typographyLabelXSmallPrimaryMedium,
  typographyBadgeSmallCondensedBold,
  typographyPTSansNarrow10,
};
